























































import { Component, Ref, Vue } from 'vue-property-decorator';
import { todoTypeManage, createCustomRenderObj, generateOptionsByKey } from './todoType';
import { exportExcelByArray, timeFormat } from '@/utils/other';
import TodoTypeModal from './components/todoTypeModal.vue';
import { Table } from 'ant-design-vue';

type ITodoTypeRow = ITodo.ITodoTypeRow;

interface IPagination {
  current: number;
  pageSize: number;
  hideOnSinglePage?: boolean;
}

const typeValueColumn = {
  slots: { title: 'typeValueTitle' },
  dataIndex: 'typeValue',
  width: '5%',
  // scopedSlots: { customRender: 'typeValue'},
};

const dataIndexList = ['projectName', 'name', 'firstCategoryName', 'secondCategoryName', 'thirdCategoryName', 'typeValue', 'active', 'formatType'];

@Component({
  name: 'TodoType',
  filters: {
    timeFormat,
  },
  components: {
    TodoTypeModal,
  },
})
export default class TodoType extends Vue {
  @Ref() private readonly todoTypeModal!: TodoTypeModal;
  @Ref() private readonly typeTable!: Table;
  private currentShowData: ITodoTypeRow[] = [];
  private currentTableData: ITodoTypeRow[] = [];
  private todoTypeManage = todoTypeManage;
  private pagination = {
    pageSize: 15,
    hideOnSinglePage: true,
  };
  private spinning = false;
  private uploading = false;
  private uploadConfig = {
    action: todoTypeManage.uploadConfig.url,
    headers: todoTypeManage.uploadConfig.headers,
  };
  get columns() {
    const projectColumn = {
      slots: { title: 'projectTitle' },
      dataIndex: 'projectName',
      width: '12%',
      filters: generateOptionsByKey(this.todoTypeList, 'projectId', 'projectName'),
      onFilter: (value: string, record: ITodoTypeRow) => {
        return record.projectId === value;
      },
      customRender: (text: string, row: ITodoTypeRow, index: number) => {
        return this.createCustomRenderObj(text, row, index, 'projectId');
      },
    };
    const nameColumn = {
      slots: { title: 'nameTitle' },
      dataIndex: 'name',
      width: '15%',
      filters: generateOptionsByKey(this.currentTableData, 'name', 'name'),
      onFilter: (value: string, record: ITodoTypeRow) => {
        return record.name === value;
      },
      customRender: (text: string, row: ITodoTypeRow, index: number) => {
        return this.createCustomRenderObj(text, row, index, 'id');
      },
    };
    const firstCategoryColumn = {
      slots: { title: 'firstCategoryTitle' },
      dataIndex: 'firstCategoryName',
      width: '10%',
      filters: generateOptionsByKey(this.currentTableData, 'firstCategoryName', 'firstCategoryName'),
      onFilter: (value: string, record: ITodoTypeRow) => {
        return record.firstCategoryName === value;
      },
      customRender: (text: string, row: ITodoTypeRow, index: number) => {
        return this.createCustomRenderObj(text, row, index, 'firstCategoryId');
      },
    };
    const secondCategoryColumn = {
      slots: { title: 'secondCategoryTitle' },
      dataIndex: 'secondCategoryName',
      width: '10%',
      filters: generateOptionsByKey(this.currentTableData, 'secondCategoryName', 'secondCategoryName'),
      onFilter: (value: string, record: ITodoTypeRow) => {
        return record.secondCategoryName === value;
      },
      customRender: (text: string, row: ITodoTypeRow, index: number) => {
        return this.createCustomRenderObj(text, row, index, 'secondCategoryId');
      },
    };
    const thirdCategoryColumn = {
      slots: { title: 'thirdCategoryTitle' },
      dataIndex: 'thirdCategoryName',
      width: '10%',
      filters: generateOptionsByKey(this.currentTableData, 'thirdCategoryName', 'thirdCategoryName'),
      onFilter: (value: string, record: ITodoTypeRow) => {
        return record.thirdCategoryName === value;
      },
      customRender: (text: string, row: ITodoTypeRow, index: number) => {
        return this.createCustomRenderObj(text, row, index, 'thirdCategoryId');
      },
    };
    const createCreaterComponent = (record: ITodoTypeRow) => this.$createElement(
      'span',
      `${record.createdName}(${timeFormat(record.createdOn)})`,
    );
    const createdNameColumn = {
      slots: { title: 'createrTitle' },
      dataIndex: 'createdName',
      width: '15%',
      align: 'center',
      customRender: (text: string, row: ITodoTypeRow, index: number) => {
        return this.createCustomRenderObj(createCreaterComponent(row), row, index, 'id');
      },
    };
    const createActiveComponent = (text: boolean) => this.$createElement(
      'AIcon',
      {
        style: {
          color: text ? '#52C41A' : '#ff4d4f',
        },
        props: {
          type: text ? 'check-circle' : 'close-circle',
        },
      },
    );
    const activeColumn = {
      slots: { title: 'activeTitle' },
      dataIndex: 'active',
      width: '5%',
      align: 'center',
      customRender: (text: boolean, row: ITodoTypeRow, index: number) => {
        return this.createCustomRenderObj(createActiveComponent(text), row, index, 'id');
      },
    };
    const createFormatLimitComponent = (text: number) => {
      let value = '';
      switch (text) {
        case 1:
          value = this.$t('todoType.onlyIntegers').toString();
          break;
        case 0:
          value = this.$t('todoType.keepTwoDecimalPlaces').toString();
        default:
          break;
      }
      return value;
    };
    const formatLimitColumn = {
      slots: { title: 'formatLimitTitle' },
      dataIndex: 'formatType',
      width: '6%',
      ellipsis: true,
      customRender: (text: number, row: ITodoTypeRow, index: number) => {
        return this.createCustomRenderObj(createFormatLimitComponent(text), row, index, 'thirdCategoryId');
      },
    };
    const createActionComponent = (record: ITodoTypeRow) => this.$createElement(
      'div',
      {class: 'action'},
      [
        this.$createElement('AButton', {
          props: {
            type: 'danger',
            shape: 'circle',
            icon: 'delete',
            size: 'small',
          },
          on: {
            click: () => this.handleDelTodoType(record),
          },
        }),
        this.$createElement('AButton', {
          props: {
            type: 'primary',
            shape: 'circle',
            icon: 'edit',
            size: 'small',
          },
          on: {
            click: () => this.editTodoType(record),
          },
        }),
      ],
    );
    const actionColumn = {
      slots: { title: 'actionTitle' },
      key: 'action',
      width: '10%',
      align: 'center',
      customRender: (text: string, row: ITodoTypeRow, index: number) => {
        return this.createCustomRenderObj(createActionComponent(row), row, index, 'id');
      },
    };
    return [
      projectColumn,
      nameColumn,
      firstCategoryColumn,
      secondCategoryColumn,
      thirdCategoryColumn,
      typeValueColumn,
      formatLimitColumn,
      createdNameColumn,
      activeColumn,
      actionColumn,
    ];
  }
  get todoTypeList() {
    this.currentTableData = this.todoTypeManage.tableData;
    return this.todoTypeManage.tableData;
  }
  private created() {
    this.refreshTodoTypes();
  }
  private destroyed() {
    todoTypeManage.clearData();
  }
  private refreshTodoTypes() {
    this.spinning = true;
    todoTypeManage.requestGetTodoTypes().then((res) => {
      this.initCurrentShowData();
    }).catch((err) => {
      this.$message.warning(err);
    }).finally(() => {
      this.spinning = false;
    });
  }
  private initCurrentShowData() {
    // 调用表格的第一个子组件，获取当前分页显示的数据；
    this.currentShowData = (this.typeTable.$children[0] as any).getCurrentPageData();
  }
  private createTodoType() {
    this.todoTypeModal.showModal(todoTypeManage.createTodoTypeRow(), true);
  }
  private editTodoType(todoTypeRow: ITodoTypeRow) {
    this.todoTypeModal.showModal(todoTypeRow, false);
  }
  private submitDelete(todoTypeId: string) {
    todoTypeManage.requestDelTodoType(todoTypeId).then((res) => {
      this.$message.success(res);
      this.initCurrentShowData();
    }).catch((err) => {
      this.$message.warning(err);
    });
  }
  private handleDelTodoType(todoType: ITodoTypeRow) {
    this.$confirm({
      title: this.$t('operation.confirmMsg', {operation: this.$t('form.delete').toString() + todoType.name}).toString(),
      onOk: () => {
        this.submitDelete(todoType.id);
      },
    });
  }
  private handleTableChange(
    pagination: IPagination,
    filters: any,
    sorter: any,
    { currentDataSource }: {currentDataSource: ITodoTypeRow[]},
  ) {
    const startIndex = (pagination.current - 1) * pagination.pageSize;
    const endIndex = pagination.current * pagination.pageSize;
    this.currentShowData = currentDataSource.slice(startIndex, endIndex);
    // 當前表格的數據 currentDataSource、this.typeTable.$children[0] as any).getLocalData()
    this.currentTableData = currentDataSource;
  }
  private createCustomRenderObj(text: any, row: ITodoTypeRow, index: number, dataKey: keyof ITodoTypeRow) {
    // 第一次加载页面 this.currentShowData 是undefined, 就取todoTypeList的第一页数据
    // handleTableChange触发后，会给this.currentShowData 赋值；
    return createCustomRenderObj(text, row, index, dataKey, this.currentShowData);
  }
  private handleSubmit() {
    this.refreshTodoTypes();
  }
  private handleExport() {
    if (this.todoTypeList.length === 0) {
      this.$message.warning('暫無數據');
      return;
    }
    const formatJson = (filterKey: string[], jsonData: ITodoTypeRow[]) => {
      return jsonData.map((item) => {
        return filterKey.map((key) => {
          return item[key as keyof ITodoTypeRow];
        });
      });
    };
    const tbodyData = formatJson(dataIndexList, this.todoTypeList);
    try {
      exportExcelByArray(`TodoType.xlsx`, dataIndexList, tbodyData);
    } catch (error) {
      this.$message.warning((error as Error).message);
    }
  }
  private templateDownload() {
    try {
      exportExcelByArray(`TodoTypeTemplate.xlsx`, dataIndexList, []);
    } catch (error) {
      this.$message.warning((error as Error).message);
    }
  }
  private handleUploadChange(obj: any) {
    if (obj.file.status === 'uploading') {
      this.uploading = true;
    }
    if (obj.file.status === 'error') {
      this.$message.warning(JSON.stringify(obj.file.response));
      this.uploading = false;
    }
    if (obj.file.status === 'done' && obj.file.response.success) {
      this.$message.success(obj.file.response.message || 'success');
      this.refreshTodoTypes();
      this.uploading = false;
    } else if (obj.file.status === 'done') {
      this.uploading = false;
      this.$message.warning(obj.file.response.message);
    }
  }
}
